class ProductComposition extends HTMLElement {
  constructor() {
    super();
    this.benefits = this.querySelectorAll('.product-composition__benefits--item');
    this.ingredients = this.querySelectorAll('.product-composition__ingredient');
  }

  connectedCallback() {
    this.benefits.forEach((benefit) => {
      const benefitIndex = benefit.dataset.benefitIndex;

      benefit.addEventListener('mouseenter', () => {
        this.highlightIngredients(benefitIndex);
      });

      benefit.addEventListener('mouseleave', () => {
        this.clearHighlightsIngredients();
      });
    });

    this.ingredients.forEach((ingredient) => {
      const ingredientIndex = ingredient.dataset.benefitIndex;

      ingredient.addEventListener('mouseenter', () => {
        this.highlightBenefits(ingredientIndex);
      });

      ingredient.addEventListener('mouseleave', () => {
        this.clearHighlightsBenefits();
      });
    });
  }

  highlightIngredients(index) {
    this.ingredients.forEach((ingredient) => {
      if (ingredient.dataset.benefitIndex === index) {
        ingredient.classList.add('product-composition__ingredient--highlight');
      }
    });
  }

  clearHighlightsIngredients() {
    this.ingredients.forEach((ingredient) => {
      ingredient.classList.remove('product-composition__ingredient--highlight');
    });
  }

  highlightBenefits(index) {
    this.benefits.forEach((benefit) => {
      if (benefit.dataset.benefitIndex === index) {
        benefit.classList.add('product-composition__benefits--item--highlight');
      }
    });
  }

  clearHighlightsBenefits() {
    this.benefits.forEach((benefit) => {
      benefit.classList.remove('product-composition__benefits--item--highlight');
    });
  }
}

customElements.define('product-composition', ProductComposition);
